import { DataFilter } from "interfaces";
import { formatValue } from "utils/formatting";

const makeRangeText = (
  filter: DataFilter.Filter,
  type?: DataFilter.ColumnType | ""
) => {
  let { operator, range } = filter;
  const n_t = !type
    ? ["ge", "gt", "lt", "le", "eq", "ne", "between"].includes(operator)
      ? "numeric"
      : "char"
    : type;

  if (n_t && !["int", "float", "numeric", "date", "time"].includes(n_t)) {
    const r = range.map((r) => r.toString()).join(", ");
    switch (operator) {
      case "in":
        return range.length === 1 ? `is ${r}` : `is one of [${r}]`;
      case "not in":
        return range.length === 1 ? `is NOT ${r}` : `is NOT one of [${r}]`;
      case "sw":
        return range.length === 1
          ? `starts with ${r}`
          : `starts with ONE OF [${r}]`;
      case "nsw":
        return range.length === 1
          ? `does NOT start with ${r}`
          : `does NOT start with ANY OF [${r}]`;
      case "ew":
        return range.length === 1
          ? `ends with ${r}`
          : `ends with ONE OF [${r}]`;
      case "new":
        return range.length === 1
          ? `does NOT end with ${r}`
          : `does NOT end with ANY OF [${r}]`;
      case "cn":
        return range.length === 1
          ? `contains ${r}`
          : `contains AT LEAST ONE OF [${r}]`;
      case "ncn":
        return range.length === 1
          ? `does NOT contain ${r}`
          : `does NOT contain ANY OF [${r}]`;
      default:
        return "";
    }
  }

  range = range.map((r) => formatValue(r, type));

  switch (operator) {
    case "between":
    case "in":
      return `is between ${range[0]} and ${range[1]}`;
    case "gt":
      return `${n_t === "date" ? "is after" : "is greater than"} ${range[0]}`;
    case "ge":
      return `${
        n_t === "date" ? "is ON or after" : "is greater than or equal to"
      } ${range[0]}`;
    case "lt":
      return `${n_t === "date" ? "is before" : "is less than"} ${range[0]}`;
    case "le":
      return `${
        n_t === "date" ? "is ON or before" : "is less than or equal to"
      } ${range[0]}`;
    case "eq":
      return `${n_t === "date" ? "is ON" : "is equal to"} ${range[0]}`;
    case "ne":
      return `${n_t === "date" ? "is NOT ON" : "is NOT equal to"} ${range[0]}`;
    default:
      return "";
  }
};

export default makeRangeText;
